import "./detials.css"
import { useNavigate } from "react-router-dom";

function TwoServices(){
          const navigate = useNavigate();

    return(
        <>
        <div className="servicedetials">
            <div className="row">
               <div className="col-md-12">
    <div className="box">
        <i className="fas fa-user-md"></i>
        <h4>Family Medicine Clinic</h4>
        <p>
            Provides comprehensive care for all family members, from children to the elderly. Services include routine check-ups for early detection of chronic diseases such as diabetes and hypertension, preventive vaccination programs, and management of long-term health conditions. The clinic is staffed by specialized family physicians who ensure integrated follow-up and personalized treatment plans tailored to each individual’s needs.
        </p>
        <p>July 14, 2025</p>
    </div>
</div>
            </div>
           <div className="row  m-2">
    <div className="buttons">
  
     <button
      className="btn w-100 btn-warning m-2"
      onClick={() => navigate(-1)}
    >
      <i className="fas fa-exclamation-triangle w-100"></i>
      Return to Service
    </button>

  
  </div>
</div>
        </div>
        </>
    )
}
export default TwoServices